import { NextSeo } from 'next-seo';
import { Fragment } from 'react';
import Header from '../../../components/Header';
import ObjectsMap from '../../../components/objects/ObjectsMap';
import ObjectsFilterMobile from '../../../components/objects/ObjectsFilterMobile';

import { useLocationProvider } from '../../../context/location';

const ObjectsMapPage = () => {

  const [locationState] = useLocationProvider();
  
  return (
    <Fragment>
      <NextSeo
        title={locationState.seo.title}
        description={locationState.seo.description}
        openGraph={{
          url: `https://${process.env.NEXT_PUBLIC_SITEDOMAIN}`,
          type: 'website',
          title: locationState.seo.title,
          description: locationState.seo.description, 
          images: [
            {
              url: '/images/og-preview.png'
            }
          ],
          site_name: process.env.NEXT_PUBLIC_SITENAME
        }}
      />
      <Header />
      <main className="core">
        <ObjectsFilterMobile isMap />
        <ObjectsMap />
      </main>
    </Fragment>
  );
};

export const getServerSideProps = () => {
  return {
    props: {}
  };
};

export default ObjectsMapPage;
